import { CoreIcon } from '../core-icon';
import driverSVG from '../../../src/images/icons/driver.svg';

export const DriverIcon = props => {
  return <CoreIcon src={driverSVG} {...props} />;
};
